export const defaultTeam = plan => (plan?.team || []).filter(member => member.effective === true).map(member => member.member_id);
export const selectedTeam = plan => (plan?.team || []).filter(member => member.effective === true);
export function teamSummary(summary, team, plan) {
  const rows = summary.map(row => ({ ...row, key: `supplier:${row.supplier_id}`, team: false }));
  for (const member of team.filter(row => row.delivery !== 'app' && row.pending_query_part_ids.length)) {
    const parts = member.pending_query_part_ids.map(query_part_id => ({ query_part_id }));
    rows.push({ key: `team:${member.member_id}`, member_id: member.member_id, name: `${member.name} · Our team`, team: true, parts,
      partNames: parts.map(part => plan?.parts.find(row => row.query_part_id === part.query_part_id)?.part_name || `Part #${part.query_part_id}`) });
  }
  return rows;
}
// Only supplier-to-supplier collisions need repair. Members cannot be opted out.
export function repairTeamPhoneCollision(pairs, ids, plan, supplierIds) {
  const keep = supplierIds.find(id => Object.values(pairs).some(pair => pair.supplier_id === id));
  return { pairs: Object.fromEntries(Object.entries(pairs).filter(([, pair]) => !supplierIds.includes(pair.supplier_id) || pair.supplier_id === keep)), ids };
}
